"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineHomepageSlide8 = exports.HomepageSlide8 = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
class HomepageSlide8 extends HTMLElement {
    constructor() {
        super();
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.innerHTML = `
    <style>
      :host {
        display: grid;
        grid-template-columns: 2fr 3fr;
        grid-gap: 1rem;
        width: 100%;
        max-width: var(--slide-max-width, 100%);
        margin: 5rem auto;
        box-sizing: border-box;
        align-items: center;
        font-family: 'quaaykop-medium', sans-serif;
      }
      
      div.title {
        font-size: 2rem;
        padding-left: 1rem;
        box-sizing: border-box;
      }
      
      div.content {
        font-size: 1.2rem;
        padding-right: 1rem;
        box-sizing: border-box;
      }
      
      img {
        width: 100%;
        grid-column: 1 / 3;
      }
      
      div.view-product {
        grid-column: 1 / 3;
        text-align: right;
        box-sizing: border-box;
      }
      
      div.view-product a {
        text-decoration: none;
        color: black;
      }
      
      div.view-product a:hover {
        color: silver;
      }
      
      span.no-split {
        white-space: nowrap;
      }
      
      @media (max-width: 600px) {
        :host {
          display: flex;
          flex-direction: column;
          width: 100%;
          padding: 1rem;
          box-sizing: border-box;
          align-items: center;
          margin: 1rem auto;
        }
        
        div.title {
          font-size: 1.7rem;
          padding: unset;
        }
        
        div.content {
          padding: unset;
        }
      }
    </style>
    <div class="title">
        AiLEENE is manufactured in one of Korea’s finest facilities.
      </div>
    <div class="content">
      CGBIO is a leading Korean biotechnology and medical device company focused on advanced regenerative biomaterials and innovative healthcare solutions, serving global markets with a broad product portfolio.<br><br>
      Their <span class="no-split">state-of-the-art</span> manufacturing facilities and continuous R&D investment ensure <span class="no-split">high-quality,</span> clinically trusted materials and devices used in orthopedics, wound care, aesthetics
    </div>
    <img src="/files/assets/images/slide-8.jpg" />
    <div class="view-product">
      <a>VIEW PRODUCT →</a>
    </div>`;
    }
}
exports.HomepageSlide8 = HomepageSlide8;
const defineHomepageSlide8 = (name) => {
    (0, lib_es2015_1.defineIfUndefined)(name, HomepageSlide8);
};
exports.defineHomepageSlide8 = defineHomepageSlide8;
